import { createContext } from "react";

let AuthContext = createContext({
  user: null,
  signin: null,
  signout: null
});

export default AuthContext;